import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Input from "../../components/Input";
import InputPassword from "../../components/InputPassword";
import {
    checkUserIsValidate,
    getSettingItem,
    register,
    setToken,
    verifyUser
} from "../../services";
import { useFormik } from "formik";
import { initialValues } from "../../utils/formsValidator/registerFormValidator";
import { validationSchema } from "../../utils/formsValidator/registerFormValidator";
import { pushToast } from "../../utils/pushToast";
import { useEffect, useState } from "react";
import { useAuthAction } from "../../context/AuthContext";
import Loading from "../../components/Loading";
import VerifyCode from "../../components/VerifyCode";
import RulesModal from "../../components/Modals/RulesModal";
import { convertToWesternNumerals, handelPrice } from "../../utils/helper";
import { useSweetAlert } from "../../context/sweetAlertContext";

export default function Register() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showVerify, setShowVerify] = useState(false);
    const [mobile, setMobile] = useState(null);
    const [referencerName, setReferencerName] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const [code, setCode] = useState(null);
    const [userCode, setUserCode] = useState(null);

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenRules, setIsOpenRules] = useState(false);
    const [password, setPassword] = useState(null);
    const { setUser } = useAuthAction();
    const [isValidReferencerCode, setIsValidReferencerCode] = useState(false);

    useEffect(() => {
    }, []);

    const checkRegistration = async () => {
        setIsLoading(true);
        try {
            const { data, status } = await getSettingItem('ActiveRegisterationInApplication');
            if (status === 200) {
                if (data.value == 'False') {
                    navigate('/login');
                }
            }
            setIsLoading(false);
        } catch (ex) {
            pushToast("خطای سرور", "error");
            setIsLoading(false);
        }
    }

    useEffect(() => {
        checkRegistration();
    }, []);

    const onSubmit = async (values) => {
        const formValues = { ...values, mobile: convertToWesternNumerals(values.mobile), password: convertToWesternNumerals(values.password) }
        setIsLoading(true);
        try {
            const { status, message } = await register(formValues);
            if (status == 200) {
                setShowVerify(true)
                setMobile(values.mobile)
                setPassword(values.password)
                setIsLoading(false);

            } else {
                pushToast(message, "error")
                setIsLoading(false);

            }

        } catch (ex) {
            setIsLoading(false);
            console.log(ex)
        }
    }
    const onVerifySubmit = async () => {
        const formValues = { password: password, mobile: mobile, code: code }
        setIsLoading(true);
        try {
            const { userInfo, userPermission, message } = await verifyUser(formValues);

            if (userInfo && userInfo.isSuccess) {
                setToken(userInfo?.data?.token)
                setUser({ userInfo: userInfo, userPermission });
                navigate('/dashboard');
                setIsLoading(false);

            } else {
                pushToast(message, "error")
                setIsLoading(false);

            }

        } catch (ex) {
            setIsLoading(false);
            console.log(ex)
        }
    }

    // const ReferencerList =async () => {
    //
    //     setIsLoading(true);
    //     try {
    //         const {data,message,status} = await UserReferencerList();
    //
    //         if (status==200) {
    //             setReferencerList(data);
    //             setIsLoading(false);
    //         } else {
    //             pushToast(message, "error")
    //             setIsLoading(false);
    //
    //         }
    //
    //     } catch (ex) {
    //         setIsLoading(false);
    //         console.log(ex)
    //     }
    // }
    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: false
    });
    useEffect(() => {
        if (searchParams.get("userCode") != null) {
            setUserCode(searchParams.get("userCode"))
            userIsValidate(searchParams.get("userCode"))
        } else {
            // userIsValidate(userCode)
            setUserCode(null)
        }
    }, [])
    const userIsValidate = async (value) => {
        setIsLoading(true)
        try {
            const values = {
                referencerCode: value,
            }
            if (value !== "") {
                const { data, result, status, message } = await checkUserIsValidate(values);
                if (status === 200) {
                    formik.setValues({ ...formik.values, validateReferencerCode: true, referenceCode: convertToWesternNumerals(value) });
                    //formik.setValues({ ...formik.values, referenceCode: value });
                    setReferencerName(message)
                    setIsValidReferencerCode(true)
                    console.log(formik.values)
                } else {
                    setIsValidReferencerCode(false)
                    setReferencerName("کد معرف نامعتبر می باشد")
                    formik.setValues({ ...formik.values, validateReferencerCode: false });

                    // formik.values["validateReferencerCode"]= false
                }
            } else {
                setIsValidReferencerCode(false)
                formik.setValues({ ...formik.values, validateReferencerCode: false });

                setReferencerName("کد معرف نامعتبر می باشد")
                // formik.values["validateReferencerCode"]= false
            }

            setIsLoading(false)
        } catch (ex) {
            pushToast("خطای سرور", "error");
            setReferencerName(null)
            setIsLoading(false)
        }
    }

    const handleCodeChange = (code) => {
        setCode(code)
    };

    const handelSelectReferencer = (id) => {

        formik.setValues({ ...formik.values, referenceCode: id });
        formik.values["referenceCode"] = id

        userIsValidate(id)
        setIsOpen(false)
    };
    return (
        <>
            {showVerify == false ?
                <div className="backgroud-image">
                    <div className="authentication-wrapper authentication-basic container-p-y">
                        <div className="authentication-inner py-4">
                            <div className="card card-border">
                                <div className="card-body">
                                    <h4 className="mb-2 text-center ">ثبت نام</h4>
                                    <p className="m-0 font-weight-light font-14 line-height-25 text-justify text-last-end mb-2">کاربر عزیز لطفاً اطلاعات و مشخصات خواسته شده را به درستی و مطابق با <b>اطلاعات شناسنامه‌ای</b> خود وارد نمایید</p>
                                    <p className="m-0 font-weight-light font-14 line-height-25 text-justify text-last-end">در صورت ثبت اطلاعات اشتباه، هیچ مبلغی به حساب شما واریز نخواهد شد و از بسیاری از مزایا، خدمات و امکانات کارسود نمی‌توانید استفاده نمایید</p>
                                    <hr />
                                    <form id="formAuthentication"
                                        className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                                        onSubmit={formik.handleSubmit} noValidate={true}>
                                        <Input
                                            type="text"
                                            className="text-start"
                                            dir="ltr"
                                            name="firstName"
                                            placeholder="نام (به فارسی)"
                                            label="نام (به فارسی)"
                                            formik={formik}
                                            icon={'bx-user'}
                                        />
                                        <Input
                                            type="text"
                                            className="text-start"
                                            dir="ltr"
                                            name="lastName"
                                            placeholder="نام خانوادگی (به فارسی)"
                                            label="نام خانوادگی (به فارسی)"
                                            formik={formik}
                                            icon={'bx-user'}
                                        />
                                        <Input
                                            type="text"
                                            className="text-start"
                                            dir="ltr"
                                            name="mobile"
                                            placeholder="تلفن همراه خود را وارد نمایید"
                                            label="موبایل"
                                            formik={formik}
                                            value={convertToWesternNumerals(formik.values.mobile)} // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formik.handleChange(e);
                                                formik.setFieldValue('mobile', convertedValue);
                                            }}
                                            icon={'bx-mobile'}

                                        />

                                        <InputPassword
                                            label="رمز عبور (حداقل 8 کاراکتر)"
                                            className="text-start"
                                            dir="ltr"
                                            name="password"
                                            placeholder="············"
                                            formik={formik}
                                            value={convertToWesternNumerals(formik.values.password)} // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formik.handleChange(e);
                                                formik.setFieldValue('password', convertedValue);
                                            }}
                                        />
                                        <InputPassword
                                            label="تکرار رمز عبور"
                                            className="text-start"
                                            dir="ltr"
                                            name="confirmPassword"
                                            placeholder="············"
                                            formik={formik}
                                            value={convertToWesternNumerals(formik.values.confirmPassword)} // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formik.handleChange(e);
                                                formik.setFieldValue('confirmPassword', convertedValue);
                                            }}
                                        />
                                        <Input
                                            value={userCode ? userCode : convertToWesternNumerals(formik.values["referenceCode"])}
                                            label2={referencerName}
                                            type="text"
                                            className={'text-start'}
                                            lableClass={isValidReferencerCode == true ? 'text-start' : 'text-start text-danger'}
                                            dir="ltr"
                                            name="referenceCode"
                                            placeholder="کد دعوت معرف خود را وارد نمایید"
                                            label="کد معرف"
                                            formik={formik}
                                            disabled={userCode ? true : false}
                                            icon={isValidReferencerCode ? 'bx-check' : 'bx-error'}
                                            onBlur={() => userIsValidate(formik.values["referenceCode"])}
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formik.handleChange(e);
                                                formik.setFieldValue('referenceCode', convertedValue);
                                            }}
                                        />
                                        {/*<p>در صورت نداشتن کد معرف، کد <span className={"text-danger"}>10047</span> را وارد نمایید</p>*/}
                                        {/*{userCode == null &&*/}
                                        {/*    <p onClick={() => setIsOpen(true)}>کد معرف ندارید ؟ <span*/}
                                        {/*        className={"selectReferenerLink"}>انتخاب کنید</span></p>*/}
                                        {/*}*/}
                                        <div className="mb-3">
                                            <div className="form-check position-relative">
                                                {/*<input className={`form-check-input ${formik.errors['terms'] ? "is-invalid" : ""}`} type="checkbox" id="terms-conditions"*/}
                                                {/*       name="terms" checked={formik.values['terms']} onChange={formik.handleChange}/>*/}
                                                <label className="form-check-label" htmlFor="terms-conditions">
                                                    با ثبت نام{" "}
                                                    <button
                                                        type="button"
                                                        className="text-blue bg-transparent border-0 p-0"
                                                        onClick={() => setIsOpenRules(true)}
                                                    >
                                                        قوانین و مقررات
                                                    </button>{" "}
                                                    را قبول می‌کنم
                                                </label>

                                                {/*{*/}
                                                {/*    formik.touched['terms'] && formik.errors['terms'] ? (<div className="invalid-feedback">{formik.errors['terms']}</div>) : null*/}
                                                {/*}*/}
                                            </div>
                                        </div>
                                        <button className="btn btn-primary d-grid w-100"
                                            disabled={!formik.isValid}>ثبت نام
                                        </button>
                                    </form>

                                    <p className="text-center">
                                        <span>حساب کاربری دارید؟</span><span>&nbsp;</span>
                                        <Link to="/login">
                                            <span>وارد شوید</span>
                                        </Link>
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="backgroud-image">
                    <div className="authentication-wrapper authentication-basic container-p-y">
                        <div className="authentication-inner py-4">
                            <div className="card card-border">
                                <div className="card-body">
                                    <div className="col-5 app-brand justify-content-center m-auto">
                                        {/*<img src="/logo.png" className={'w-100 '}/>*/}
                                    </div>
                                    <hr />


                                    <p className="mb-2 text-center">کد پیامک شده به {mobile} را وارد نمایید</p>
                                    <div
                                        className={`needs-validation mb-3 text-center `}
                                    >
                                        <div className="mb-3 ">
                                            <VerifyCode length={4} onCodeChange={handleCodeChange} />
                                        </div>

                                        <button className="btn btn-primary d-grid w-100 " type={"button"} onClick={onVerifySubmit}>تایید
                                        </button>
                                    </div>

                                    <p className="text-center">

                                        <Link onClick={() => setShowVerify(false)}>
                                            <span>ویرایش تلفن همراه</span>
                                        </Link>
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                isLoading ? (<Loading />) : null
            }

            <RulesModal
                isOpen={isOpenRules}
                setIsOpen={setIsOpenRules}
            />
        </>
    )
}